module.exports = __webpack_public_path__ + "img/2.cda53186.png";